import React, { useState } from 'react';
import {
  Button,
  Menu,
  MenuItem,
  Typography,
  IconButton,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
interface CreateNewItemProps {
    onNewRole: () => void;
    onNewGroup: () => void;
  }

const CreateNewItem: React.FC<CreateNewItemProps> = ({
    onNewRole,
    onNewGroup
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCreateRole = () => {
    handleClose();
    onNewRole()
    // Navigate to or open modal for Role creation
  };

  const handleCreateRoleGroup = () => {
    handleClose();
    console.log("Create Role Group Clicked");
    onNewGroup()
    // Navigate to or open modal for Role Group creation
  };

  return (
    <div>
      {/* Button to open menu */}
      <Button
        startIcon={<AddIcon />}
        onClick={handleClick}
        variant="contained"
        color="primary"
        sx= {{fontSize : '1.0rem', 
              textTransform: 'capitalize', 
            }}
      >
        Create New Item
      </Button>
      {/* Menu for options */}
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <MenuItem onClick={handleCreateRole}>
          <Typography variant="body1">Role</Typography>
        </MenuItem>
        <MenuItem onClick={handleCreateRoleGroup}>
          <Typography variant="body1">Role Group</Typography>
        </MenuItem>
      </Menu>
    </div>
  );
};

export default CreateNewItem;
